var map = {
	"./drug-cat(old).png": "60c1",
	"./drug-cat-3.png": "d47a",
	"./drug-cat-single.png": "fe61",
	"./drug-cat.png": "aa39",
	"./drug-dog(old).png": "1e78",
	"./drug-dog.png": "553b",
	"./medicine-cat.png": "29f4",
	"./medicine-dog.png": "c110",
	"./question-cat.png": "ec86",
	"./question-dog.png": "b10a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f353";